import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import toast from './modules/public/toast.js';
import home from './modules/home.js';
import course from './modules/course.js';
import header from './modules/header.js';
import footer from './modules/footer.js';
import mine from './modules/mine.js';
import homeCourse from './modules/homeCourse.js';
import faceToface from './modules/courseCenter/faceToface';
import group from './modules/courseCenter/group';
import online from './modules/courseCenter/online.js';
import groupOnline from './modules/courseCenter/groupOnline.js';
import newsign from './modules/courseCenter/newsign'
import localforage from 'localforage';
import supplementaryCardInfo from './modules/studentCard/supplementaryCardInfo';
import orderList from './modules/orderList/orderList';
import studentCardList from './modules/studentCard/studentCardList';
// 在线诊断课
import chooseCityAndGrade from './modules/chooseCityAndGrade'
import pop from './modules/pop'
import toastBlack from './modules/public/toastBlack'

export function createStore () {
  const store = new Vuex.Store({
    modules: {
      toastBlack,
      pop,
      chooseCityAndGrade,
      toast,
      home,
      course,
      mine,
      header,
      footer,
      homeCourse,
      faceToface,
      group,
      online,
      groupOnline,
      newsign,
      supplementaryCardInfo,
      orderList,
      studentCardList
    },
    strict: true,
    state: {
      schools: [],
      meta: {
        title: '学而思·爱智康官网_好未来中小学1对1辅导品牌',
        keywords: '学而思爱智康,智康一对一',
        description: '学而思·爱智康致力于为小、初、高各学龄段(6-18岁)的孩子提供线上与线下相融合的全场景、全学科的个性化辅导课程，涵盖 1 对 1 精品课、8 人小班课、在线课等授课形式，帮助孩子培养六大学习能力，构建完整的知识图谱。',
        favicon: ''
      }
    },
    actions: {
      setMeta(context, payload) {
        return context.commit('setMeta', payload);
      }
    },
    mutations: {

      setMeta(state, preload) {
        state.meta = {
          title: preload.title||'',
          keywords: preload.keywords||'',
          description: preload.description||'',
          favicon: preload.favicon||''
        }
      },
      storeChange(state, preload) {
        // 此处存储整个state,用做离线存储
        localforage.setItem('izk-web-app', state).then(function(value) {
          console.log('离线存储: ', value);
        }).catch(function(err) {
          // 错误处理
          console.log('离线存储错误: ', err);
        })
      }
    }
  });

  // 订阅store的mutation，state变化后存入localforage，用于离线存储
  // store.subscribe((mutation, state)=> {
  //   if(mutation.type == "route/ROUTE_CHANGED" || mutation.type == 'isShowHeader' || mutation.type == 'isShowFooter'){
  //     return;
  //   }
  //   if(mutation.type == "toast"){
  //     return;
  //   }
  //   console.log('离线存储： ', mutation, state);
  //   //此处存储整个state,用做离线存储
  //   localforage.setItem('izk-web-app', state).then(function(value){
  //     //console.log('离线存储: ', value);
  //   }).catch(function(err){
  //     //错误处理
  //     console.log('离线存储错误: ', err);
  //   })
  //   //console.warn('每次state变化之后的mutation：', mutation);
  //   //console.warn('每次state变化之后的state：', state);
  // })

  return store;
}



// WEBPACK FOOTER //
// ./src/stores/store.js